var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-unit"},[_c('p',{staticClass:"upload-unit-key"},[_vm._v(_vm._s(_vm.iconKey)+"：")]),_c('div',{staticClass:"upload-unit-right"},[_c('img',{staticClass:"upload-unit-right-icon",attrs:{"src":_vm.currentIconURL}}),_c('file-select',{staticClass:"upload-unit-right-file-select",on:{"onFileSelect":_vm.onFileSelectSelect}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }